import { render, staticRenderFns } from "./ValidateApplicationsList.vue?vue&type=template&id=b944924c"
import script from "./ValidateApplicationsList.vue?vue&type=script&lang=js"
export * from "./ValidateApplicationsList.vue?vue&type=script&lang=js"
import style0 from "./ValidateApplicationsList.vue?vue&type=style&index=0&id=b944924c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports